define('frontend-common-components/objectStorageConfig/js/constants/events',[],function () {
    'use strict';

    return {
        closeAddStorage: 'storage:closeAddStorage',
        awsConfigAdded: 'storage:awsConfigAdded',
        azureConfigAdded: 'storage:azureConfigAdded',
        configSaving: 'storage:configSaving',
        bucketListLoading: 'storage:bucketListLoading',
        bucketListComplete: 'storage:bucketListComplete',
        containerListLoading: 'storage:containerListLoading',
        containerListComplete: 'storage:containerListComplete',
        configSaveSuccess: 'storage:configSaveSuccess',
        configSaveFailure: 'storage:configSaveFailure',
        typeSelected: 'storage:typeSelected'
    };
});
